class LazyShopLogin extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;

    this.controller = new AbortController();
    this.template = this.querySelector('template');
    this.desktopMedia = window.matchMedia('(min-width: 768px)');
    if (!this.template) return;

    this.desktopMedia.addEventListener('change', this.#handleViewportChange, {
      signal: this.controller.signal,
    });

    if (window.Shopify?.designMode) {
      this.#activate();
      return;
    }

    this.#observeWhenEligible();
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.intersectionObserver?.disconnect();
    this.controller = null;
  }

  #handleViewportChange = () => {
    this.#observeWhenEligible();
  };

  #observeWhenEligible() {
    if (this.loaded || !this.desktopMedia.matches) {
      this.intersectionObserver?.disconnect();
      return;
    }

    if (!('IntersectionObserver' in window)) {
      this.#activate();
      return;
    }

    this.intersectionObserver?.disconnect();
    this.intersectionObserver = new IntersectionObserver(this.#handleIntersection);
    this.intersectionObserver.observe(this.closest('[popover], dialog') || this);
  }

  #handleIntersection = (entries) => {
    if (!entries.some((entry) => entry.isIntersecting)) return;
    this.intersectionObserver?.disconnect();
    this.#activate();
  };

  async #activate() {
    if (this.loaded || !this.template) return;
    this.loaded = true;

    try {
      await import(this.dataset.moduleSrc);
    } catch (error) {
      console.warn('Unable to load Shop account actions.', error);
      return;
    }

    if (!this.isConnected) return;
    this.replaceChildren(this.template.content.cloneNode(true));
  }
}

if (!customElements.get('lazy-shop-login')) {
  customElements.define('lazy-shop-login', LazyShopLogin);
}
